import axios from "./index";
import { buildLoginError } from "./login_error";

export default {
  loginByGoogleIdToken(callback, params) {
    axios.post("/api/v1/google_login/callback", {
      id_token: params.id_token,
    }).then(() =>{
      callback({ loggedIn: true, error: null });
    }).catch(error => {
      console.log(error);
      callback({ loggedIn: false, error: buildLoginError(error) });
    });
  },
};
